<template>
  <div v-if="role === 'retoucher'" class="uk-width-auto uk-text-center">
    <div class="tm-order-count uk-box-shadow-medium">
      <div>
        <md-icon>pending_actions</md-icon>
        {{count_new_orders}} / {{count_personal_orders}}
      </div>
      <div class="uk-dropdown tm-dropdown tm-dropdown-bottom-center" data-uk-dropdown="pos: bottom-center; offset: 15">
        {{ getTooltipContent }}
      </div>
    </div>
    <div class="uk-background-muted uk-width-large uk-margin-auto uk-padding-small uk-margin-top" v-if="false && downtime.ordersIdsInCacheUserIdsCollectionFirst && Object.keys(downtime.ordersIdsInCacheUserIdsCollectionFirst).length > 0">

      <div class="uk-grid uk-text-center uk-flex-center" data-uk-grid>
        <div class="uk-text-bold">Следующий:</div>
        <div>{{downtime.ordersIdsInCacheUserIdsCollectionFirst.order_id}}</div>
        <div>{{downtime.ordersIdsInCacheUserIdsCollectionFirst.order_status}}</div>
      </div>
    </div>
    <div class="uk-margin" v-if="false && downtime.ordersIdsInCacheUserIdsCollection && downtime.ordersIdsInCacheUserIdsCollection.length > 0">
      <div class="uk-text-bold uk-text-center ">Следующие заказы</div>
      <div class="uk-grid  uk-text-left uk-text-small uk-child-width-1-1 uk-margin" data-uk-grid>
        <div v-for="item in downtime.ordersIdsInCacheUserIdsCollection" :key="item.order_id" >
          <div class="uk-padding-small uk-background-muted">
            <div class="uk-grid uk-grid-divider uk-flex-middle" data-uk-grid>
              <div class="uk-text-bold">
                {{item.order_id}}
              </div>
              <div class="uk-width-expand">
                {{item}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CountNewOrdersFuncBased",
  props: {
    local_page_keys: {
      type: Object,
      require: true
    },
    downtime: {
      type: Object,
      require: true,
    },
    role: {
      type: String,
      require: true,
    },

  },
  data: () => ({

  }),
  methods: {
    async fetchCountNewOrders() {
      let data;

      this.$emit("fetch-personal-orders-count", this.count_personal_orders);
    },

  },
  async mounted() {
  },
  created() {

  },
  computed: {
    count_new_orders(){
      return this.downtime && this.downtime.count_new_orders ? this.downtime.count_new_orders : 0;
    },
    count_personal_orders(){
      return this.downtime && this.downtime.count_personal_orders ? this.downtime.count_personal_orders : 0;
    },
    getTooltipContent() {
      //return this.local_page_keys.tooltip_order_count_part_1 + ' ' + this.count_new_orders + ' ' + this.local_page_keys.tooltip_order_count_part_2 + ' ' + this.count_personal_orders + ' ' + this.local_page_keys.tooltip_order_count_part_3;

      let count_new = this.count_new_orders;
      let count_personal = this.count_personal_orders;
      let content = '';

      if (this.downtime.on_shift) {
        if (this.downtime.user_can_take_order && count_personal === 0) {
          content = this.local_page_keys.tooltip_order_count_count_new1_count_personal0_green;
        } else if (this.downtime.user_can_take_order && count_personal > 0) {
          content = this.local_page_keys.tooltip_order_count_count_new1_count_personal1_green;
        } else if (!this.downtime.user_can_take_order) {
          content = this.local_page_keys.tooltip_order_count_count_new0_count_personal0_gray;
        }
      } else {

        if (count_personal === 0) {
          content = this.local_page_keys.tooltip_order_count_red;
        } else if (count_personal > 0) {
          content = this.local_page_keys.tooltip_order_count_blue;
        }
      }
      return content.replace('{count_new}', count_new).replace('{count_personal}', count_personal);
    }
  },
  beforeDestroy() {
  }
}
</script>
<style></style>